<template>
  <div class="main-page-wrapper p0 overflow-hidden">
    <!-- header start -->
    <HeaderTwo />
    <!-- header end -->
    <!-- hero area start -->
    <div class="fancy-hero-five">
      <div class="bg-wrapper">
        <div class="container">
          <div class="text-center row">
            <div class="col-xl-9 m-auto">
              <h1 class="heading flex align-items-center">
                <img alt=""
                     src="../../assets/images/logo/cross.svg"
                     width="50"
                     height="50"
                     class="heading-icon"/>
                Our Process
              </h1>
            </div>
          </div>
        </div>
      </div> <!-- /.bg-wrapper -->
    </div>
    <!-- hero area end -->

    <!-- details area start -->
    <div class="service-details-one">
      <div class="container">
        <div class="row">
          <ul class="process-steps-list">
            <li v-for="step in content.steps" :key="step._id">
              {{ step.title }}
              <svg class="steps-chevron" fill="#000000" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.061 19.061 17.121 12l-7.06-7.061-2.122 2.122L12.879 12l-4.94 4.939z"/>
              </svg>
            </li>
          </ul>

          <div class="fancy-feature-forty lg-container" id="product">
            <div class="container">

              <div v-for="step in content.steps" :key="step._id" class="block-style-thirtyEight">
                <div class="row align-items-start">
                  <div class="col-xl-5 col-lg-6" data-aos="fade-right">
                    <h2 class="step-heading">{{ step.heading }}</h2>
                    <div class="step-text mt-20">
                      <PortableText :value="step.blockText" />
                    </div>
                    <ul class="features-list mt-30">
                      <li v-for="feature in step.features"
                          :key="feature"
                          class="feature">
                        <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="800" height="800" viewBox="0 0 78.369 78.369">
                            <path d="M78.049 19.015 29.458 67.606a1.094 1.094 0 0 1-1.548 0L.32 40.015a1.094 1.094 0 0 1 0-1.547l6.704-6.704a1.095 1.095 0 0 1 1.548 0l20.113 20.112 41.113-41.113a1.095 1.095 0 0 1 1.548 0l6.703 6.704a1.094 1.094 0 0 1 0 1.548z"/>
                        </svg>
                        {{ feature }}
                      </li>
                    </ul>
                    <a :href="`mailto:sales@marshallprint.co.uk?subject=Inquiry&body=---%0AContext: ${ step.cta.linkText } -- link`" class="step-cta btn mt-30 py-3">
                      {{ step.cta.linkText }}
                      <svg class="step-cta-chevron" fill="#000000" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.061 19.061 17.121 12l-7.06-7.061-2.122 2.122L12.879 12l-4.94 4.939z"/>
                      </svg>
                    </a>
                  </div>
                  <div
                      class="step-img-col col-xl-7 col-lg-5 col-md-8 ms-auto text-end d-flex align-items-start"
                      data-aos="fade-left">
                    <div class="step-img-wrapper d-flex align-items-center justify-content-start mh-50 position-relative md-mt-70">
                      <img :src="step.image.image.asset.url" :alt="step.image.alt" class="step-image" />
                      <div class="step-shape"
                           data-aos="fade-up"
                           data-aos-delay="300"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="strip">
      <div class="container">
        <img src="../../assets/images/logo/cross.svg"
             alt=""
             height="50"
             width="50"
             class="strip-icon" />
        <h2 class="services-heading text-center">{{ content.processSubtitle }}</h2>
        <ul class="services-list">
          <li v-for="service in content.serviceList" :key="service">
            <svg xmlns="http://www.w3.org/2000/svg"
                 xml:space="preserve"
                 width="800"
                 height="800"
                 class="service-checkmark"
                 viewBox="0 0 78.369 78.369">
                <path d="M78.049 19.015 29.458 67.606a1.094 1.094 0 0 1-1.548 0L.32 40.015a1.094 1.094 0 0 1 0-1.547l6.704-6.704a1.095 1.095 0 0 1 1.548 0l20.113 20.112 41.113-41.113a1.095 1.095 0 0 1 1.548 0l6.703 6.704a1.094 1.094 0 0 1 0 1.548z"/>
            </svg>
            {{ service }}
          </li>
        </ul>
      </div>
    </div>
    <faq-accordion />
    <!-- details area end -->

    <!-- footer start -->
    <FooterSeven :dark_bg="true" :dark_btn="true" />
    <!-- footer end -->
  </div>
</template>

<script>
import HeaderTwo from '@/components/common/Headers/HeaderTwo.vue';
import FooterSeven from '@/components/common/Footers/FooterSeven.vue';
import sanity from "../../../sanity.js";
import FaqAccordion from "@/components/content/faq-accordion.vue";
import {PortableText} from "@portabletext/vue";
import {useHead} from "@vueuse/head";
export default {
  name:'ServiceDetails',
  components: {FaqAccordion, HeaderTwo, PortableText, FooterSeven },
  data() {
    return {
      loading: true,
      content: [],
    }
  },
  methods: {
    async fetchData() {
      const query = `*[_type == "process"]{
        _id,
        title,
        slug,
        steps[]->{
          title,
          heading,
          excerpt,
          blockText,
          features[],
          cta{
            ...
          },
          image{
            alt,
            image{
              asset->{
                metadata {
                  dimensions
                },
                url
              }
            }
          }
        },
        processSubtitle,
        serviceList[],
        seo {
          title,
          description,
          keywords,
          ogImage {
            asset->{
              url
            }
          }
        }
      }[0]`;
      this.error = this.home = null;
      this.loading = true;
      try {
        const content = await sanity.fetch(query);
        this.loading = false;
        this.content = content;
      } catch (error) {
        this.error = error;
      }
    },
  },
  async created() {
    await this.fetchData();
    useHead({
      title: `${this.content?.title} | Marshall Print`,
      meta: [
        { name: 'description', content: this.content?.seo?.description },
        { name: 'keywords', content: this.content?.seo?.keywords },
        // { property: 'og:title', content: this.content?.seo?.title },
        // { property: 'og:description', content: this.content?.seo?.description },
        // { property: 'og:image', content: this.content?.seo?.ogImage?.asset.url },
      ]
    })
  },
}
</script>

<style lang="scss" scoped>
.strip {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: var(--lightgrey);
  font-weight: bold;
  padding: 6rem 0;
}
.fancy-hero-five {
  background-color: var(--darkblue);
  margin: 8rem 0 0 0;
  padding: 6rem 0;
  @media (max-width: 767px) {
    margin: 5rem 0 0 0;
    padding: 4rem 0;
  }
  .heading {
    color: white;
    display: flex;
    font-size: 4rem;
    font-weight: bold;
    align-items: center;
    justify-content: center;
    @media (max-width: 767px) {
      font-size: 2.5rem;
    }
  }
}

.heading-icon {
  margin-right: 2rem;
}
.service-details-one {
  padding: 3rem 0 0 0;
  @media (max-width: 1200px) {
    padding: 2rem 0 0 0;
  }
}
.fancy-feature-forty {
  margin: 2rem auto;
  position: relative;
  @media (max-width: 1200px) {
    margin: 0 auto;
  }
}
.block-style-thirtyEight .row {
  margin: 2rem auto 10rem auto;
  @media (max-width: 1200px) {
    margin: 2rem auto 5rem auto;
  }
}
.block-style-thirtyEight:nth-child(odd) .row {
  flex-direction: row-reverse;
}
.block-style-thirtyEight {
  &:nth-child(odd){
    .row .step-img-col {
      justify-content: flex-start;
      @media (max-width: 1200px) {
        justify-content: center;
      }
    }
  }
  &:nth-child(even){
    .row .step-img-col {
      justify-content: flex-end;
      @media (max-width: 1200px) {
        justify-content: center;
      }
    }
  }
}

.block-style-thirtyEight .row .step-heading {
  font-size: 2.5rem;
  font-weight: 900;
  @media (max-width: 1200px) {
    font-size: 2rem;
  }
}
.block-style-thirtyEight .row .step-text {
  font-size: 1.3rem;
  line-height: 1.5;
}
.block-style-thirtyEight .row .step-shape {
  display: block;
  height: 20rem;
  position: absolute;
  top: -1.5rem;
  right: -3rem;
  width: 20rem;
  z-index: -10;
  @media (max-width: 1200px) {
    height: 12rem;
    top: 0;
    right: -1rem;
    width: 12rem;
  }
}
.block-style-thirtyEight:nth-child(1) .row .step-shape {
  background-color: var(--pink);
}
.block-style-thirtyEight:nth-child(2) .row .step-shape {
  background-color: var(--lightblue);
}
.block-style-thirtyEight:nth-child(3) .row .step-shape {
  background-color: var(--orange);
}
.block-style-thirtyEight:nth-child(4) .row .step-shape {
  background-color: var(--green);
}
.block-style-thirtyEight .row .step-image {
  height: 30rem;
  margin: 0;
  width: 30rem;
  @media (max-width: 1200px) {
    height: 18rem;
    width: 18rem;
  }
}

.block-style-thirtyEight .row .step-img-wrapper {
  height: 30rem;
  margin: 2rem 0 0 0;
  padding: 3rem 0 0 0;
  position: relative;
  width: 30rem;
  z-index: 10;
  @media (max-width: 1200px) {
    height: 20rem;
    padding: 1.5rem 0 0 0;
    width: 20rem;
  }
  //@media (max-width: 1200px) {
  //  height: 20rem;
  //  padding: 1.5rem 0 0 0;
  //  width: 20rem;
  //}
}
.block-style-thirtyEight .row .step-img-wrapper:before {
  display: block;
  font-size: 8rem;
  font-weight: 900;
  height: 8rem;
  left: 0;
  position: absolute;
  top: 0;
  @media (max-width: 1200px) {
    font-size: 4rem;
    top: 0;
  }
}
.block-style-thirtyEight:nth-child(1) .row .step-img-wrapper:before {
  color: var(--pink);
  content: "01";
}
.block-style-thirtyEight:nth-child(2) .row .step-img-wrapper:before {
  color: var(--lightblue);
  content: "02";
}
.block-style-thirtyEight:nth-child(3) .row .step-img-wrapper:before {
  color: var(--orange);
  content: "03";
}
.block-style-thirtyEight:nth-child(4) .row .step-img-wrapper:before {
  color: var(--green);
  content: "04";
}
.block-style-thirtyEight .row .feature svg {
  height: 1rem;
  width: 1rem;
}
.block-style-thirtyEight:nth-child(1) .row .feature svg {
  fill: var(--pink);
}
.block-style-thirtyEight:nth-child(2) .row .feature svg {
  fill: var(--lightblue);
}
.block-style-thirtyEight:nth-child(3) .row .feature svg {
  fill: var(--orange);
}
.block-style-thirtyEight:nth-child(4) .row .feature svg {
  fill: var(--green);
}

.block-style-thirtyEight .row .step-cta {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-weight: bold;
  padding: 0;
  text-align: left;
}
.block-style-thirtyEight:nth-child(1) .row .step-cta {
  color: var(--pink);
}
.block-style-thirtyEight:nth-child(2) .row .step-cta {
  color: var(--lightblue);
}
.block-style-thirtyEight:nth-child(3) .row .step-cta {
  color: var(--orange);
}
.block-style-thirtyEight:nth-child(4) .row .step-cta {
  color: var(--green);
}

.block-style-thirtyEight .row .step-cta svg {
  height: 2rem;
  width: 2rem;
}
.block-style-thirtyEight:nth-child(1) .row .step-cta svg {
  fill: var(--pink);
}
.block-style-thirtyEight:nth-child(2) .row .step-cta svg {
  fill: var(--lightblue);
}
.block-style-thirtyEight:nth-child(3) .row .step-cta svg {
  fill: var(--orange);
}
.block-style-thirtyEight:nth-child(4) .row .step-cta svg {
  fill: var(--green);
}
.process-steps-list {
  display: flex;
  justify-content: center;
  list-style: none;
  margin: 0 auto 2rem auto;
  padding: 0;
}
.process-steps-list li {
  color: var(--darkblue);
  display: inline-block;
  font-size: 1rem;
  font-weight: bold;
  margin: 0 1rem;
  @media (max-width: 767px) {
    font-size: 0.875rem;
    margin: 0 0.5rem;
  }
}
.process-steps-list li .steps-chevron {
  height: 2rem;
  width: 2rem;
  @media (max-width: 767px) {
    height: 1.25rem;
    width: 1.25rem;
  }
}
.process-steps-list li:nth-child(1) .steps-chevron {
  fill: var(--pink);
}
.process-steps-list li:nth-child(2) .steps-chevron {
  fill: var(--lightblue);
}
.process-steps-list li:nth-child(3) .steps-chevron {
  fill: var(--orange);
}
.process-steps-list li:nth-child(4) .steps-chevron {
  fill: var(--green);
}
.strip-icon {
  margin: 0 auto 2rem auto;
}
.service-checkmark {
  fill: var(--pink);
  height: 1rem;
  width: 1rem;
}

.step-heading {
  font-weight: bold;
}

.services-heading {
  font-size: 3rem;
  font-weight: bold;
  margin: 0 auto;
  max-width: 60rem;
  position: relative;
  @media (max-width: 767px) {
    font-size: 1.75rem;
  }
}
.services-list {
  list-style: none;
  margin: 2rem 0;
  padding: 0;
  column-count: 2;
  column-gap: 2.5rem;
}

.services-list li {
  color: var(--darkblue);
  display: flex;
  align-items: center;
  break-inside: avoid;
  margin-bottom: 0.25rem;
}

.services-list .service-checkmark {
  flex: 0 0 1.5rem;
  height: 1.5rem;
  width: 1.5rem;
  margin-right: 0.75rem;
}

@media (max-width: 768px) {
  .services-list {
    column-count: 1;
  }
}

</style>
